import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation } from "react-router";
import { useDispatch, useSelector } from 'react-redux';
import PageBreadcrumb from "../common/PageBreadCrumb";
import PageMeta from "../common/PageMeta";
import ComponentCard from "../common/ComponentCard";
import Label from "../form/Label";
import Input from "../form/input/InputField";
import TextArea from "../form/input/TextArea";
import Select from "../form/Select";
import Switch from "../form/switch/Switch";
import Button from "../ui/button/Button";
import Alert from "../../components/ui/alert/Alert";
import { CheckLineIcon, CloseLineIcon, EyeCloseIcon, EyeIcon } from "../../icons";
import { getPaymentSetting, updatePaymentSetting } from "../../actions/settingAction";
import { checkAuth, emptyReduxUser } from "../../actions/userAction";
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../helpers/userAuth';


export default function EditPayments() {

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const checkAuthFailed = useSelector(state => state.userReducer.checkAuthFailed);

  const hiddenInputRef = useRef();

  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [isActive, setActive] = useState(false);

  const getPaymentSettingRes = useSelector(state => state.settingReducer.getPaymentSetting);
  const getPaymentSettingFailed = useSelector(state => state.settingReducer.getPaymentSettingFailed);

  const updatePaymentSettingRes = useSelector(state => state.settingReducer.updatePaymentSetting);
  const updatePaymentSettingFailed = useSelector(state => state.settingReducer.updatePaymentSettingFailed);

  const [name, setName] = useState("");
  const [errorName, setErrorName] = useState(false);

  const [liveMode, setLiveMode] = useState(true);
  const [errorLiveMode, setErrorLiveMode] = useState(false);

  const [UpiId, setUpiId] = useState("");
  const [errorUpiId, setErrorUpiId] = useState(false);

  const [apiKey, setApiKey] = useState("");
  const [errorApiKey, setErrorApiKey] = useState(false);

  const [apiTestKey, setApiTestKey] = useState("");
  const [errorApiTestKey, setErrorApiTestKey] = useState(false);

  const [status, setStatus] = useState(true);
  const [errorStatus, setErrorStatus] = useState(false);

  useEffect(() => {
    if(checkAuthFailed.statusCode == 401){
      dispatch(emptyReduxUser());
      logout();
      navigate("/signin");
    }
  }, [checkAuthFailed]);

  var calls = 1;

  useEffect(() => {
    calls++;
    dispatch(checkAuth());
    dispatch(getPaymentSetting());
  }, []);

  useEffect(() => {

    if(typeof getPaymentSettingRes != "undefined" && getPaymentSettingRes.statusCode == 200){
      let data = getPaymentSettingRes.data.payments;
      const upiData = data.find(item => item.name === "UPI");
      if (upiData) {
        setName(upiData.name);
        setUpiId(upiData.accountId);
        setApiKey(upiData.apiKey);
        setApiTestKey(upiData.apiTestKey);
        setLiveMode(upiData.LiveMode === "1");
        setStatus(upiData.Status === "1");
      } 
    }

  }, [getPaymentSettingRes]);


  useEffect(() => {

    if(typeof updatePaymentSettingRes != "undefined" && updatePaymentSettingRes.statusCode == 200){

      toast.success(updatePaymentSettingRes.message, {position: "top-right", autoClose:4000});

      setShowSuccessAlert(true);

      setTimeout(()=>{
        setShowSuccessAlert(true);
      },5000);

    }

  }, [updatePaymentSettingRes]);

  const handleChangeNew = (input, event) => {
    
    var value = (input == "liveMode"  || input == "status") ? event : event.target.value;

    if(input == "liveMode"){
      setLiveMode(value);
    }

    if(input == "UpiId"){
      setUpiId(value);
    }

    if(input == "apiKey"){
      setApiKey(value);
    }

    if(input == "apiTestKey"){
      setApiTestKey(value);
    }

    if(input == "status"){
      setStatus(value);
    }

  };


  const handleSubmit = (e) => {

    e.preventDefault();

    const name = hiddenInputRef.current.value;

    setErrorName(false);
    setErrorUpiId(false);
    setErrorApiKey(false);
    setErrorApiTestKey(false);

    var err = [];

    if(name.replace(/\s/g, '') == ""){
      err.push("name");
      setErrorName(true);
    }
    if(UpiId.replace(/\s/g, '') == ""){
      err.push("UpiId");
      setErrorUpiId(true);
    }
    if(apiKey.replace(/\s/g, '') == ""){
      err.push("ApiKey");
      setErrorApiKey(true);
    }
    if(apiTestKey.replace(/\s/g, '') == ""){
      err.push("ApiTestKey");
      setErrorApiTestKey(true);
    }
    
    
    if(err.length === 0){
        let data = {
          "name" : name,
          "account_id" : UpiId,
          "api_key" : apiKey,
          "api_test_key" : apiTestKey,
          "live_mode" : liveMode,
          "status" : status,
        };
        var id = name; 
        dispatch(updatePaymentSetting(data, id));
    } else {
      toast.error("Invalid data. Please fill all the fields properly.", {position: "bottom-right", autoClose:4000});
    }

  }

  
  return (        
    <div>
      <PageMeta
        title="Payments | Chit Fund Management System"
        description="Acount profile info - Chit Fund Management System"
      />
      <PageBreadcrumb pageTitle="Payments" />
      <div className="grid grid-cols-1 gap-6 xl:grid-cols-2">
      <div className="space-y-9">
          <ComponentCard title="UPI info">
            {(
              showSuccessAlert
              ? 
              <Alert
                variant="success"
                title="Done!"
                message="UPI info successfully updated."
                showLink={false}
              />
              : 
              null
            )}
            <form onSubmit={handleSubmit} className='fadein'>
              <div className="grid grid-cols-1 gap-6 xl:grid-cols-1">
                <div className="space-y-6">

                  <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
                    <div>
                    <input
                      type="hidden"
                      name="name"
                      value="UPI"
                      ref={hiddenInputRef}
                    />
                    </div>
                    <Switch
                      label={liveMode ? 'Live Mode' : 'Test Mode'}
                      checked={liveMode}
                      defaultChecked={true}
                      onChange={(e) => handleChangeNew("liveMode", e)}
                    />
                  </div>

                  <div>
                    <Label>UPI ID</Label>
                    <Input 
                      type="text" 
                      placeholder="Enter the UPI ID" 
                      error={errorUpiId}
                      value={UpiId} 
                      onChange={(e) => handleChangeNew("UpiId", e)} 
                      hint={errorUpiId ? "This field is required." : ""}
                    />
                  </div>

                  <div>
                    <Label>Live Key</Label>
                    <Input 
                      type="text" 
                      placeholder="Enter the Live Key" 
                      error={errorApiKey}
                      value={apiKey} 
                      onChange={(e) => handleChangeNew("apiKey", e)} 
                      hint={errorApiKey ? "This field is required." : ""}
                    />
                  </div>

                  <div>
                    <Label>Test Key</Label>
                    <Input 
                      type="text" 
                      placeholder="Enter the Test Key" 
                      error={errorApiTestKey}
                      value={apiTestKey} 
                      onChange={(e) => handleChangeNew("apiTestKey", e)} 
                      hint={errorApiTestKey ? "This field is required." : ""}
                    />
                  </div>

                  <div className="flex gap-4">
                    <Switch
                      label={status ? 'Enable' : 'Disable'}
                      checked={status}
                      defaultChecked={true}
                      onChange={(e) => handleChangeNew("status", e)}
                    />
                  </div>
                </div>

                <div className="space-x-6 flex justify-between">
                  <div></div>
                  <Button size="sm" variant="primary" startIcon={<CheckLineIcon />}>
                    Save
                  </Button>
                </div>
              </div>
            </form>
          </ComponentCard>
        </div>

      </div>
      <ToastContainer />
    </div>
  );
}
